// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__Z1KSS","rootCenter":"LoadMoreObserver_rootCenter__3xRGu","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3cICx"};